import { CLOUDFLARE_SITE_ID, WEBAPP_URL } from "@calcom/lib/constants";
import { useQuery } from "@tanstack/react-query";
import { useSyncExternalStore } from "react";

const STALE_MS = 5 * 60 * 1000;

function mainAppHost(): string {
  try {
    return new URL(WEBAPP_URL).host.toLowerCase();
  } catch {
    return "";
  }
}

function subscribe(): () => void {
  return () => undefined;
}

function clientHost(): string {
  return window.location.host.toLowerCase();
}

function serverHost(): string {
  return "";
}

function readSitekey(body: unknown): string | null {
  if (typeof body !== "object" || body === null || !("sitekey" in body)) return null;
  const sitekey = body.sitekey;
  if (typeof sitekey !== "string" || sitekey.length === 0) return null;
  return sitekey;
}

export function useTurnstileSiteKey(): string | undefined {
  const host = useSyncExternalStore(subscribe, clientHost, serverHost);
  const onMainApp = host.length > 0 && host === mainAppHost();
  const query = useQuery({
    queryKey: ["turnstile-sitekey", host],
    enabled: host.length > 0 && !onMainApp,
    staleTime: STALE_MS,
    queryFn: async (): Promise<string | null> => {
      const response = await fetch("/api/turnstile-sitekey");
      if (!response.ok) return null;
      return readSitekey(await response.json());
    },
  });
  if (onMainApp) return CLOUDFLARE_SITE_ID || undefined;
  if (query.data) return query.data;
  // A failed or empty lookup must still render a captcha: the booking API rejects requests without a token,
  // and the build-time key is valid on the main app and every *.book.select host.
  if (query.isError || query.data === null) return CLOUDFLARE_SITE_ID || undefined;
  return undefined;
}
